module.exports = __webpack_public_path__ + "static/media/vortex-gear-bg.6dc53e12.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/vortex-gear-bg.png
// module id = 474
// module chunks = 0